
export const inputselect="Please select at least one input.";
export const createBotModal={
    bot_name:"Please enter Bot name.",
    bot_desc:"Please enter Bot description."
}
export const userModal={
    first_name:"Please enter user first name.",
    username:"Please enter user name.",
    email:"Please enter user email.",
    password:"Please enter user password.",
    role:"Please select user role.",
    phone_no:"Please enter user phone number."
}